import { magicNumbers } from 'utils';

export const telegramFiltersInitialState = {
  wordCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'wordCloudFilter',
    translateKey: 'filter:wordCloud',
  },
  hashtagCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'hashtagCloudFilter',
    translateKey: 'filter:hashtagCloud',
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'telegram',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
      },
      view: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:viewCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:contentBasedOn',
  },
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  // contentTypeFilter: {
  //   hasFilter: false,
  //   isOpen: false,
  //   selectedValue: 'both', // both or original or copy
  //   componentName: 'contentTypeFilter',
  //   translateKey: 'filter:contentType',
  // },
  mediaTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'telegram',
    componentName: 'mediaTypeFilter',
    translateKey: 'filter:mediaType',
  },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    platform: 'telegram',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    hasIncludeExclude: false,
    filterType: 'include',
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: false,
    platform: 'telegram',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
};
